export const FACTOR_NAMES = [
  "pe", "ev_ebitda", "fcf_yield", "roe", "roic", "operating_margin",
  "revenue_growth", "eps_growth", "debt_equity", "interest_coverage",
  "momentum_6m", "volatility",
] as const;

export type FactorName = (typeof FACTOR_NAMES)[number];
export type FactorDirection = "higher_is_better" | "lower_is_better";
export type FactorCategory = "value" | "quality" | "growth" | "financialHealth" | "market";
export type FactorObservation = {
  ticker: string;
  factorName: FactorName;
  rawValue: number | null;
  normalizedScore: number | null;
  /** Canonical percentile field. */
  percentile: number | null;
  /** Backward-compatible alias used by current clients. */
  industryPercentile: number | null;
  category: FactorCategory;
  direction: FactorDirection;
  dataDate: string;
  source: string;
};
export type CategoryScores = {
  value: number | null;
  quality: number | null;
  growth: number | null;
  financialHealth: number | null;
  market: number | null;
};